// extracted by mini-css-extract-plugin
module.exports = {"node":"Node_node__38uoJ","minimal":"Node_minimal__3sbyt","alias":"Node_alias__VPI6D"};